import React from 'react';
import { ArrowRight, BrandMark } from './icons';
import { Link } from 'react-router-dom';

const AuthorBio: React.FC = () => (
  <div className="mt-10 p-5 bg-surface rounded-xl border border-surface-border flex gap-4 items-start">
    <div className="w-12 h-12 rounded-xl bg-neutral-800 flex-shrink-0 flex items-center justify-center text-white font-bold text-lg select-none">
      <BrandMark size={30} />
    </div>
    <div className="min-w-0">
      <p className="text-sm font-semibold text-ink mb-0.5">Color Match</p>
      <p className="text-xs text-ink-secondary leading-relaxed">
        Color Match publishes and maintains practical color guides alongside its tools.
        Check the sources and revision notes on each updated guide, and report
        reproducible issues through our contact page.
      </p>
      <Link
        to="/about"
        className="text-xs text-brand-600 hover:underline mt-1 inline-flex items-center gap-1.5"
      >
        More about Color Match <ArrowRight size={14} />
      </Link>
    </div>
  </div>
);

export default AuthorBio;
